
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  source: 'error',
  description: 'Guide to understanding and troubleshooting partner errors.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const ErrorReference = makeShortcode("ErrorReference");
const Checkbox = makeShortcode("Checkbox");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Partner errors' subtitle='Guide to troubleshooting partner errors' mdxType="Header" />
    <h4 {...{
      "id": "customer_not_found"
    }}><strong parentName="h4">{`CUSTOMER_NOT_FOUND`}</strong></h4>
    <ErrorReference type='PARTNER_ERROR' error='CUSTOMER_NOT_FOUND' subtitle='Customer not found' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The end customer could not be found.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Check the end customer ID.`}</p>
      </Checkbox>
      <Checkbox mdxType="Checkbox">
        <p>{`Ensure that you're making the request in the correct Plaid environment.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "flowdown_not_complete"
    }}><strong parentName="h4">{`FLOWDOWN_NOT_COMPLETE`}</strong></h4>
    <ErrorReference type='PARTNER_ERROR' error='FLOWDOWN_NOT_COMPLETE' subtitle='Flowdown not complete' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-1"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`A flowdown, which is a prerequisite for creating an end customer, has not been completed.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-1"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Complete a flowdown in the `}<a href="https://dashboard.plaid.com/settings/compliance/us-oauth-institutions">{`Plaid Dashboard`}</a>{`.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "questionnaire_not_complete"
    }}><strong parentName="h4">{`QUESTIONNAIRE_NOT_COMPLETE`}</strong></h4>
    <ErrorReference type='PARTNER_ERROR' error='QUESTIONNAIRE_NOT_COMPLETE' subtitle='Questionnaire not complete' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-2"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`A security questionnaire, which is a prerequisite for creating an end customer, has not been submitted.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-2"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Submit a security questionnaire in the `}<a href="https://dashboard.plaid.com/overview/questionnaire">{`Plaid Dashboard`}</a>{`.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "customer_not_ready_for_enablement"
    }}><strong parentName="h4">{`CUSTOMER_NOT_READY_FOR_ENABLEMENT`}</strong></h4>
    <ErrorReference type='PARTNER_ERROR' error='CUSTOMER_NOT_READY_FOR_ENABLEMENT' subtitle='Customer not ready for enablement' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-3"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The end customer requires manual approval from Plaid's Partnerships team.`}</li>
        <li parentName="ul">{`The end customer has been denied access to the Plaid API.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-3"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Submit your request again after the end customer's status has been updated to `}<inlineCode parentName="p">{`PENDING_ENABLEMENT`}</inlineCode>{`.`}</p>
      </Checkbox>
      <Checkbox mdxType="Checkbox">
        <p>{`Talk to your partner account manager.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "customer_already_enabled"
    }}><strong parentName="h4">{`CUSTOMER_ALREADY_ENABLED`}</strong></h4>
    <ErrorReference type='PARTNER_ERROR' error='CUSTOMER_ALREADY_ENABLED' subtitle='Customer already enabled' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-4"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The end customer has already been enabled.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-4"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Determine why your integration is attempting to enable end customers more than once.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "customer_already_created"
    }}><strong parentName="h4">{`CUSTOMER_ALREADY_CREATED`}</strong></h4>
    <ErrorReference type='PARTNER_ERROR' error='CUSTOMER_ALREADY_CREATED' subtitle='Customer already created' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-5"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The end customer has already been created.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-5"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Determine why your integration is attempting to create end customers more than once.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "logo_required"
    }}><strong parentName="h4">{`LOGO_REQUIRED`}</strong></h4>
    <ErrorReference type='PARTNER_ERROR' error='LOGO_REQUIRED' subtitle='Logo required' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-6"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`A logo is required for this customer because the `}<inlineCode parentName="li">{`create_link_customization`}</inlineCode>{` field was set to `}<inlineCode parentName="li">{`true`}</inlineCode>{` and the co-branded consent field is in use.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-6"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Add a logo to the request.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "invalid_logo"
    }}><strong parentName="h4">{`INVALID_LOGO`}</strong></h4>
    <ErrorReference type='PARTNER_ERROR' error='INVALID_LOGO' subtitle='Invalid logo' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-7"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The logo is not a valid base64-encoded string of a PNG of size 1024x1024.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-7"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Check the logo size, file type, and encoding.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "contact_required"
    }}><strong parentName="h4">{`CONTACT_REQUIRED`}</strong></h4>
    <ErrorReference type='PARTNER_ERROR' error='CONTACT_REQUIRED' subtitle='Contact required' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-8"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`A billing or technical contact is required, either in the API request or in the Dashboard.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-8"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Add a billing and/or technical contact to your API request or in the `}<a href='https://dashboard.plaid.com/settings/company/profile'>{`Dashboard`}</a>{`.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "assets_under_management_required"
    }}><strong parentName="h4">{`ASSETS_UNDER_MANAGEMENT_REQUIRED`}</strong></h4>
    <ErrorReference type='PARTNER_ERROR' error='ASSETS_UNDER_MANAGEMENT_REQUIRED' subtitle='Assets Under Management required' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-9"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The `}<inlineCode parentName="li">{`assets_under_management`}</inlineCode>{` field is required because you have a monthly service commitment, but it was omitted from your API request.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-9"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Set the `}<inlineCode parentName="p">{`assets_under_management`}</inlineCode>{` field.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "customer_removal_not_allowed"
    }}><strong parentName="h4">{`CUSTOMER_REMOVAL_NOT_ALLOWED`}</strong></h4>
    <ErrorReference type='PARTNER_ERROR' error='CUSTOMER_REMOVAL_NOT_ALLOWED' subtitle='Removal not allowed' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-10"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`You have attempted to remove an end customer that has already been enabled in the Production environment, which is not allowed.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-10"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`If you need to remove a Production-enabled end customer, talk to your account manager.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "oauth_registration_error"
    }}><strong parentName="h4">{`OAUTH_REGISTRATION_ERROR`}</strong></h4>
    <ErrorReference type='PARTNER_ERROR' error='OAUTH_REGISTRATION_ERROR' subtitle='OAuth Registration Error' server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-11"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`End customer error encountered while registering with OAuth institutions.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-11"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Log in to the end customer's Dashboard from the `}<a parentName="p" {...{
            "href": "https://dashboard.plaid.com/partner/customers-summary"
          }}>{`Partner End Customer Summary`}</a>{` page, and update the fields flagged in the error in the Compliance Center.`}</p>
      </Checkbox>
    </ErrorReference>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "customer_not_found",
        level: 4,
        title: "CUSTOMER_NOT_FOUND",
      },
{
        id: "flowdown_not_complete",
        level: 4,
        title: "FLOWDOWN_NOT_COMPLETE",
      },
{
        id: "questionnaire_not_complete",
        level: 4,
        title: "QUESTIONNAIRE_NOT_COMPLETE",
      },
{
        id: "customer_not_ready_for_enablement",
        level: 4,
        title: "CUSTOMER_NOT_READY_FOR_ENABLEMENT",
      },
{
        id: "customer_already_enabled",
        level: 4,
        title: "CUSTOMER_ALREADY_ENABLED",
      },
{
        id: "customer_already_created",
        level: 4,
        title: "CUSTOMER_ALREADY_CREATED",
      },
{
        id: "logo_required",
        level: 4,
        title: "LOGO_REQUIRED",
      },
{
        id: "invalid_logo",
        level: 4,
        title: "INVALID_LOGO",
      },
{
        id: "contact_required",
        level: 4,
        title: "CONTACT_REQUIRED",
      },
{
        id: "assets_under_management_required",
        level: 4,
        title: "ASSETS_UNDER_MANAGEMENT_REQUIRED",
      },
{
        id: "customer_removal_not_allowed",
        level: 4,
        title: "CUSTOMER_REMOVAL_NOT_ALLOWED",
      },
{
        id: "oauth_registration_error",
        level: 4,
        title: "OAUTH_REGISTRATION_ERROR",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
